module.exports = __webpack_public_path__ + "img/3.72c1978b.png";